import React, { useState, useEffect, useRef } from 'react';
import Util from '../../script/util';
import './index.scss';

export default function AudioModal(props) {
  const [play, setPlay] = useState(false);
  const [playSrc, setPlaySrc] = useState(null);
  const vadioElement = useRef(null);
  const timer = useRef(null);
  //音频播放
  const playAudio = (event) => {
    if (play) {
      audioEnded();
    } else {
      setPlay(true);
      setPlaySrc(Util.transImgUrl(props.data.voiceUrl));
    }
    event && event.stopPropagation();
  };
  //音频停止
  const audioEnded = (event) => {
    setPlay(false);
    setPlaySrc(null);
    vadioElement.current.pause();
    event && event.stopPropagation();
  };
  useEffect(() => {
    if (play && playSrc) {
      let audios = document.querySelectorAll('audio');
      audios.forEach((audio) => {
        audio.pause();
      });
      vadioElement.current.play();
      //强制结束
      if (props.data.voiceLength) {
        let voiceLen =
          props.data.voiceLength > 15 ? props.data.voiceLength : 15;
        timer.current = setTimeout(audioEnded, voiceLen * 1000);
      }
    }
    return () => {
      clearTimeout(timer.current);
    };
  }, [play, playSrc, props.data]);
  return (
    <span className={play ? `audio hover` : `audio`} onClick={playAudio}>
      <audio
        style={{ display: 'none' }}
        src={playSrc}
        onPause={audioEnded}
        onEnded={audioEnded}
        ref={vadioElement}
      />
      <i className={play ? 'play' : null} />
    </span>
  );
}
